import { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';

interface LinkTextProps {
  to: string;
  externalLink: boolean;
  className?: string;
  target?: '_blank' | '_self';
  testId?: string;
}

export function LinkText({
  to,
  children,
  target = '_blank',
  externalLink,
  className,
  testId,
}: PropsWithChildren<LinkTextProps>) {
  return externalLink ? (
    <a href={to} target={target} rel='noopener noreferrer' className={className} data-testid={testId}>
      {children}
    </a>
  ) : (
    <Link to={to} className={className} target={target} data-testid={testId}>
      {children}
    </Link>
  );
}
